module.exports = __webpack_public_path__ + "media/images/newPicture-7ea960d4d550c1f442907f5fab881424.svg";